import React from "react";
import useForegetPassAcitons from "../../assets/Hooks/getForgetPassActions";
import Loading from "../../assets/containers/loadingDialog";
import OTP from "../../assets/components/Otpcontainer";

const ForgetpassFirstpage = () => {
  const {
    nationalCode,
    handleChangeNationalCodeInput,
    loading,
    handleSendForgetPassWord,
  } = useForegetPassAcitons();
  return (
    <>
      <h5 className="text-center">فراموشی رمز عبور</h5>
      <form>
        <p className="text-center mt-5">کد ملی خود را وارد نمایید</p>
        <input
          placeholder="کدملی"
          value={nationalCode}
          onChange={handleChangeNationalCodeInput}
          name="nationalCode"
          autoComplete="off"
        />
        {loading ? (
          <Loading
            className={"d-flex justify-content-center mt-4 mb-2"}
            size={30}
          />
        ) : (
          <button onClick={handleSendForgetPassWord}>تایید</button>
        )}
      </form>
      <OTP resestPassOTP={true} />
    </>
  );
};

export default ForgetpassFirstpage;
